import { ENTITY_LABELS } from "../../utils/labelMapping";

// ─── OVERVIEW CONFIG ──────────────────────────────────────────────────────────
function getOverviewConfig() {
  return [
    {
      name: "Product Description, Snippets and Themes",
      selector: "div[class*='BrandInsights_brand__']",
      id: "snippet_theme",
      is_active: true,
      is_xpath: false,
    },
    {
      name: ENTITY_LABELS.productIndexScore,
      selector: "div[class*='BrandScore_brand_index_wrapper_']",
      id: "brand_index_score",
      is_active: true,
      is_xpath: false,
    },
  // {
  //   name: "Secondary Category Product Index Score",
  //   selector: "#secondary_id",
  //   id: "sec_category_brand_index_score",
  //   is_active: true,
  //   is_xpath: false,
  // },
    {
      name: `${ENTITY_LABELS.rank} Details`,
      selector: "#reach_id",
      id: "reach_details",
      is_active: true,
    },
    {
      name: "Sentiment Details",
      selector: "#sentiment_id",
      id: "sentiment_details",
      is_active: true,
    },
    {
      name: "Positive Sentiment Examples",
      selector: 'img[alt="5"], img[alt="4"]',
      id: "positive_sentiment_examples",
      is_active: true,
    },
    {
      name: "Negative Sentiment Examples",
      selector: 'img[alt="1"], img[alt="2"]',
      id: "negative_sentiment_examples",
      is_active: true,
    },
    {
      name: ENTITY_LABELS.productDimension,
      selector: "div[class*='Taxonomy_card__']",
      id: "prod_dim",
      is_active: true,
      is_xpath: false,
      generate_summary: true,
    },
    {
    name: ENTITY_LABELS.purchaseCriteria,
      selector: "div[class*='CategoryDims_card_']",
      id: "purchase_criteria",
      is_active: true,
      is_xpath: false,
      generate_summary: true,
    },
    {
      name: `${ENTITY_LABELS.purchaseCriteria} Details`,
      selector: "#print-pdf",
      id: "purchase_criteria_details",
      is_active: true,
      is_xpath: false,
    },
    {
      name: "Positive and Negative Attributes",
      selector: ".MuiBox-root:has(> div[class*='MuiGrid-container'])",
      id: "positivenegative_attributes",
      is_active: true,
      is_xpath: false,
      generate_summary: true,
    },
  ];
}

// ─── CATEGORY CONFIG ──────────────────────────────────────────────────────────
function getCategoryConfig() {
  return [
    {
      name: "RBI",
      selector: "#rbi_pc",
      id: "category_brand_index_score",
      is_active: true,
    // show_change: true,
  },
  // {
  //   name: "Visibility",
  //   selector: "#rank_id",
  //   id: "llm_reach",
  //   is_active: true,
  //   show_change: true,
  // },
  // {
  //   name: "Sentiment",
  //   selector: "#fav_id",
  //   id: "llm_sentiment",
  //   is_active: true,
  //   show_change: true,
  // },
    {
      name: ENTITY_LABELS.productDimension,
      selector: "#bra_id",
      id: "category_prod_dim",
      is_active: true,
    // show_change: true,
    },
    {
    name: ENTITY_LABELS.purchaseCriteria,
      selector: "#pur_id",
      id: "category_purchase_criteria",
      is_active: true,
    // show_change: true,
    },
    {
      name: `${ENTITY_LABELS.purchaseCriteria} Details`,
      selector: "#print-pdf",
      id: "category_purchase_criteria_details",
      is_active: true,
    },
    {
      name: "Positive Attributes",
      selector: "//h6[text()='Positive Attributes']/parent::div",
      id: "category_positive_attributes",
      is_active: true,
      is_xpath: true,
    },
    {
      name: "Negative Attributes",
      selector: "//h6[text()='Negative Attributes']/parent::div",
      id: "category_negative_attributes",
      is_active: true,
      is_xpath: true,
    },
  ];
}

// ─── COMPETITION CONFIG ───────────────────────────────────────────────────────
function getCompetitionConfig() {
  return [
    {
      name: "Primary Category",
      selector: "#primary_id",
      id: "competition_brand_index_score",
      is_active: true,
    // show_change: true,
  },
  // {
  //   name: "Secondary Category",
  //   selector: "#secondary_id",
  //   id: "sec_competition_brand_index_score",
  //   is_active: true,
  //   show_change: true,
  // },
    {
      name: ENTITY_LABELS.productDimension,
      selector: "#brand_pillars_id",
      id: "competition_brand_pillars",
      is_active: true,
      is_xpath: false,
    },
    {
    name: ENTITY_LABELS.purchaseCriteria,
      selector: "#purchase_criteria_id",
      id: "competition_purchase_criteria",
      is_active: true,
      is_xpath: false,
    },
    {
     name: `${ENTITY_LABELS.purchaseCriteria} Details`,
      selector: "#print-pdf",
      id: "competition_purchase_criteria_details",
      is_active: true,
    },
    {
      name: "Positive Attributes",
      selector: "//h6[text()='Positive Attributes']/parent::div",
      id: "competition_positive_attributes",
      is_active: true,
      is_xpath: true,
    },
    {
      name: "Negative Attributes",
      selector: "//h6[text()='Negative Attributes']/parent::div",
      id: "competition_negative_attributes",
      is_active: true,
      is_xpath: true,
    },
  ];
}

// ─── LLM CONFIG ───────────────────────────────────────────────────────────────
function getLlmConfig() {
  return [
    {
      name: "RBI",
      selector: "#rbi_pc",
      id: "llm_brand_index_score",
      is_active: true,
    // show_change: true,
  },
  // {
  //   name: "Visibility",
  //   selector: "#rank_id",
  //   id: "llm_reach",
  //   is_active: true,
  //   show_change: true,
  // },
  // {
  //   name: "Sentiment",
  //   selector: "#fav_id",
  //   id: "llm_sentiment",
  //   is_active: true,
  //   show_change: true,
  // },
    {
      name: ENTITY_LABELS.productDimension,
      selector: "#bra_id",
      id: "llm_prod_dim",
      is_active: true,
    // show_change: true,
    },
    {
    name: ENTITY_LABELS.purchaseCriteria,
      selector: "#pur_id",
      id: "llm_purchase_criteria",
      is_active: true,
    // show_change: true,
    },
    {
      name: `${ENTITY_LABELS.purchaseCriteria} Details`,
      selector: "#print-pdf",
      id: "llm_purchase_criteria_details",
      is_active: true,
    },
    {
      name: "Positive Attributes",
      selector: "//h6[text()='Positive Attributes']/parent::div",
      id: "llm_positive_attributes",
      is_active: true,
      is_xpath: true,
    },
    {
      name: "Negative Attributes",
      selector: "//h6[text()='Negative Attributes']/parent::div",
      id: "llm_negative_attributes",
      is_active: true,
      is_xpath: true,
    },
  ];
}

// ─── MARKET CONFIG ────────────────────────────────────────────────────────────
function getMarketConfig() {
  return [
    {
      name: "RBI",
      selector: "#rbi_pc",
      id: "market_brand_index_score",
      is_active: true,
    // show_change: true,
  },
  // {
  //   name: "Visibility",
  //   selector: "#rank_id",
  //   id: "market_reach",
  //   is_active: true,
  //   show_change: true,
  // },
  // {
  //   name: "Sentiment",
  //   selector: "#fav_id",
  //   id: "market_sentiment",
  //   is_active: true,
  //   show_change: true,
  // },
    {
      name: ENTITY_LABELS.productDimension,
      selector: "#bra_id",
      id: "market_prod_dim",
      is_active: true,
    // show_change: true,
    },
    {
    name: ENTITY_LABELS.purchaseCriteria,
      selector: "#pur_id",
      id: "market_purchase_criteria",
      is_active: true,
    // show_change: true,
    },
    {
      name: `${ENTITY_LABELS.purchaseCriteria} Details`,
      selector: "#print-pdf",
      id: "market_purchase_criteria_details",
      is_active: true,
    },
    {
      name: "Positive Attributes",
      selector: "//h6[text()='Positive Attributes']/parent::div",
      id: "market_positive_attributes",
      is_active: true,
      is_xpath: true,
    },
    {
      name: "Negative Attributes",
      selector: "//h6[text()='Negative Attributes']/parent::div",
      id: "market_negative_attributes",
      is_active: true,
      is_xpath: true,
    },
  ];
}

// ─── PERSONA CONFIG ───────────────────────────────────────────────────────────
function getPersonaConfig() {
  return [
    {
      name: "RBI",
      selector: "#rbi_pc",
      id: "persona_brand_index_score",
      is_active: true,
    // show_change: true,
  },
  // {
  //   name: "Reach",
  //   selector: "#rank_id",
  //   id: "persona_reach",
  //   is_active: true,
  //   show_change: true,
  // },
  // {
  //   name: "Sentiment",
  //   selector: "#fav_id",
  //   id: "persona_sentiment",
  //   is_active: true,
  //   show_change: true,
  // },
    {
      name: ENTITY_LABELS.productDimension,
      selector: "#bra_id",
      id: "persona_prod_dim",
      is_active: true,
    // show_change: true,
    },
    {
    name: ENTITY_LABELS.purchaseCriteria,
      selector: "#pur_id",
      id: "persona_purchase_criteria",
      is_active: true,
    // show_change: true,
    },
    {
     name: `${ENTITY_LABELS.purchaseCriteria} Details`,
      selector: "#print-pdf",
      id: "persona_purchase_criteria_details",
      is_active: true,
    },
    {
      name: "Positive Attributes",
      selector: "//h6[text()='Positive Attributes']/parent::div",
      id: "persona_positive_attributes",
      is_active: true,
      is_xpath: true,
    },
    {
      name: "Negative Attributes",
      selector: "//h6[text()='Negative Attributes']/parent::div",
      id: "persona_negative_attributes",
      is_active: true,
      is_xpath: true,
    },
  ];
}

// ─── SOURCE CONFIG — no ENTITY_LABELS, safe at module level ──────────────────
const sourceConfig = [
  {
    name: `${ENTITY_LABELS.product} Query Sources`,
    selector: "#product_id",
    id: "source_brand_source",
    is_active: true,
    is_xpath: false,
  },
  {
    name: "Category Query Sources",
    selector: "#category_id",
    id: "source_category_source",
    is_active: true,
    is_xpath: false,
  },
];

// ─── ACTION CONFIG — no ENTITY_LABELS, safe at module level ──────────────────
const actionConfig = [
  {
    id: "actions_table",
    name: "Actions Table",
    selector: "#FocusArea",
    is_active: true,
    is_xpath: false,
  },
];

// ─── MAIN EXPORT — function so all configs build fresh on every call ──────────
export function getInitialProdTabs() {
  return [
    { id: "overview", label: "Overview", config: getOverviewConfig() },
    { id: "category", label: "Category", config: getCategoryConfig() },
    { id: "competition", label: "Competition", config: getCompetitionConfig() },
    { id: "llm", label: "LLM", config: getLlmConfig() },
    { id: "market", label: "Market", config: getMarketConfig() },
    { id: "persona", label: "Personas", config: getPersonaConfig() },
    { id: "source", label: "Sources", config: sourceConfig },
    { id: "actions", label: "Actions", config: actionConfig },
  ];
}